import { render, staticRenderFns } from "./CountryProfiles.vue?vue&type=template&id=12053858&"
import script from "./CountryProfiles.vue?vue&type=script&lang=js&"
export * from "./CountryProfiles.vue?vue&type=script&lang=js&"
import style0 from "./CountryProfiles.vue?vue&type=style&index=0&id=12053858&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports